import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

import { log } from '@app/shared/utils/logger';
import { Modal } from './Modal';
import { UserAgreementSection } from '@app/shared/ui/organisms/Instructions';
import { ScrollArea, Button } from '@app/shared/ui/atoms/Common';

interface UserAgreementModalProps {
  isOpen: boolean;
  onContinue: () => void;
}

export function UserAgreementModal({ isOpen, onContinue }: UserAgreementModalProps) {
  const { t } = useTranslation();

  useEffect(() => {
    void log({ level: 'warn', message: 'UserAgreementModal', extra: { isOpen } });
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      displayCloseButton={false}
      contentClassName="h-[80vh] mt-4 shadow-blue"
      hiddenTitle="User agreement"
    >
      <ScrollArea className="text-left">
        <UserAgreementSection />
      </ScrollArea>
      <Button onClick={onContinue}>{t('common.continue')}</Button>
    </Modal>
  );
}
